import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function updateMaterialInfo(data) {
  return request({
    url: `${v2Host}/res_store/update?id=${data.queryId}`,
    method: 'post',
    data: data
  })
}
